<template>
  <div>
    <h3 class="text-center mb-4">Reservar Habitaciones</h3>


<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055;">
  <div class="toast align-items-center text-white"
       :class="toastColor"
       role="alert"
       aria-live="assertive"
       aria-atomic="true"
       v-if="mostrarToast">
    <div class="d-flex">
      <div class="toast-body">
        <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast" aria-label="Close"></button>
    </div>
  </div>
</div>

    <!-- Fechas -->
  <div class="row mb-3">
  <div class="col-md-6">
    <label class="form-label">Fecha de Inicio</label>
    <input
      type="date"
      v-model="formulario.fechaInicio"
      class="form-control"
      @change="actualizarFechaFin"
    />
  </div>
<!-- :min= "hoy"-->
  <div class="col-md-6">
    <label class="form-label">Fecha de Fin</label>
    <input
      type="date"
      v-model="formulario.fechaFin"
      class="form-control"
      :min="minFechaFin"
    />
  </div>
</div>


    <!-- Habitaciones disponibles -->
    <div v-if="Object.keys(habitacionesPorTipo).length > 0" class="mt-4">
      <h5 class="mb-4 text-center">Habitaciones disponibles:</h5>
      <div class="habitaciones-grid">
        <div v-for="(habitacionesTipo, tipo) in habitacionesPorTipo" :key="tipo" class="habitacion-card-wrapper">
          <div class="card h-100 shadow-sm">
            <div class="card-header text-center fw-bold">{{ tipo }}</div>
            <ul class="list-group list-group-flush">
              <li v-for="habitacion in habitacionesTipo" :key="habitacion.IdHabitacion"
                  class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <strong>Habitacion # {{ habitacion.Numero }}</strong><br />
                  <small>Descripción: {{ habitacion.tipo?.Descripcion }}</small>
                </div>
                <button class="btn btn-outline-primary btn-sm" @click="agregarReserva(habitacion)">Agregar</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Tarifas -->
   <div v-if="Object.keys(tarifasAgrupadas).length > 0" class="mt-5">
  <h5 class="mb-4 text-center">Precios por Tipo de Habitación</h5>
  <div class="habitaciones-grid">
    <div v-for="(grupo, tipo) in tarifasAgrupadas" :key="tipo" class="habitacion-card-wrapper">
      <div class="card h-100 shadow-sm">
        <div class="card-header text-center fw-bold">{{ tipo }}</div>

        <!-- Si hay tarifas -->
        <ul v-if="grupo.tarifas.length > 0" class="list-group list-group-flush">
          <li v-for="tarifa in grupo.tarifas" :key="tarifa.IdTarifaPersona" class="list-group-item text-center">
            {{ tarifa.CantidadPersonas }} Persona(s) - Q{{ tarifa.Precio }}
          </li>
        </ul>

        <!-- Si NO hay tarifas -->
        <div v-else class="p-3 text-center text-muted">
          <i class="bi bi-exclamation-circle"></i>
          <p class="mb-0 small">No hay precios configurados</p>
        </div>

        <!-- 🔑 Promociones debajo -->
        <div v-if="grupo.promociones && grupo.promociones.length" class="p-3 border-top">
          <h6 class="fw-bold">Promociones Activas:</h6>
          <ul class="mb-0">
            <li v-for="promo in grupo.promociones" :key="promo.IdPromocion">
              {{ promo.Nombre }}:
              {{ formatDate(promo.FechaInicio) }} - {{ formatDate(promo.FechaFin) }},
              {{ promo.PorcentajeDescuento }}% OFF
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</div>


    <!-- Datos del huésped -->
    <h3 ref="huespedForm" class="text-center mb-4 mt-10">Registrar Huésped</h3>

    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label">Teléfono</label>
        <input
          type="text"
          v-model="formulario.huesped.Telefono"
          class="form-control"
          required
          maxlength="8"
          @input="filtrarSoloNumeros"
          @blur="buscarHuespedPorTelefono"
          @keyup.enter="buscarHuespedPorTelefono"
          :disabled="huespedEncontrado && !modoEdicion"
          placeholder="Ej: 12345678"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label">Nombre</label>
        <input type="text" v-model="formulario.huesped.Nombre" class="form-control"
               :disabled="huespedEncontrado && !modoEdicion" />
      </div>

      <div class="col-md-6">
        <label class="form-label">Apellido</label>
        <input type="text" v-model="formulario.huesped.Apellido" class="form-control"
               :disabled="huespedEncontrado && !modoEdicion" />
      </div>

      <div class="col-md-6">
        <label class="form-label">Empresa (Opcional)</label>
        <input type="text" v-model="formulario.huesped.Empresa" class="form-control"
               :disabled="huespedEncontrado && !modoEdicion" />
      </div>

      <div class="col-md-6">
        <label class="form-label">NIT (Opcional)</label>
        <input type="text" v-model="formulario.huesped.NIT" class="form-control"
               :disabled="huespedEncontrado && !modoEdicion" />
      </div>

      <div class="col-md-6">
        <label class="form-label">Placas (Opcional)</label>
        <div class="input-group">
          <select
            v-model="tipoPlaca"
            class="form-select"
            style="max-width: 100px;"
            :disabled="huespedEncontrado && !modoEdicion"
          >
            <option value="P0-">P0-</option>
            <option value="C0-">C0-</option>
          </select>
          <input
            type="text"
            v-model="numeroPlaca"
            class="form-control"
            placeholder="Ej: 232DSA"
            maxlength="10"
            :disabled="huespedEncontrado && !modoEdicion"
            @input="actualizarPlacaCompleta"
          />
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label">DPI (Opcional)</label>
        <input type="text" v-model="formulario.huesped.DPI" class="form-control"
               :disabled="huespedEncontrado && !modoEdicion" />
      </div>
      <div class="col-md-6">
        <label class="form-label">Correo <span class="text-muted">(Opcional)</span></label>
        <input type="email" v-model="formulario.huesped.Correo" class="form-control"
               placeholder="correo@ejemplo.com"
               :disabled="huespedEncontrado && !modoEdicion" />
        <small
          v-if="formulario.huesped.Correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formulario.huesped.Correo)"
          class="text-danger">
          <i class="bi bi-exclamation-triangle-fill"></i> Correo inválido — se omitirá en la factura FEL
        </small>
      </div>

      <!-- Botones de acción -->
      <div v-if="huespedEncontrado" class="col-md-12 text-end mt-3">
        <button v-if="!modoEdicion" class="btn btn-warning me-2" @click="habilitarEdicion">Editar</button>
        <button v-if="modoEdicion" class="btn btn-success me-2" @click="actualizarHuesped">Guardar Cambios</button>
        <button v-if="!modoEdicion" class="btn btn-danger" @click="eliminarHuesped">Eliminar</button>
      </div>
    </div>

   <!-- Habitaciones seleccionadas -->
<h4 class="text-center mb-4 mt-5">Habitaciones Agregadas</h4>

<div v-if="formulario.habitacionesSeleccionadas.length > 0" class="table-responsive">
  <table class="table table-hover table-bordered text-center align-middle">
    <thead class="table-primary">
      <tr>
        <th>Habitación</th>
        <th>Tipo</th>
        <th>Precio X noche</th>
      <!--  <th>Descuento</th> -->
        <th>Precio Final</th>
        <th>Personas Alojadas</th>
        <th>Cantidad Niños</th>
        <th>Acción</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(habitacion, index) in formulario.habitacionesSeleccionadas" :key="index">
        <td>{{ habitacion.Numero }}</td>
        <td>
          {{ habitacion.tipo }}
          <br>
          <small class="text-muted">({{ habitacion.CantidadCamas || 1 }} cama{{ (habitacion.CantidadCamas || 1) > 1 ? 's' : '' }})</small>
        </td>
        <td>Q{{ habitacion.precioBase?.toFixed(2) || 0 }}</td>
       <!--<td>{{ habitacion.descuento || 0 }}%</td>-->
        <td>Q{{ habitacion.precio?.toFixed(2) || 0 }}</td>
        <td>
          <input
            type="number"
            v-model="habitacion.CantidadPersonasAlojadas"
            min="1"
            class="form-control text-center"
            @change="actualizarPrecio(index)"
          />
        </td>
        <td>
  <input type="number" v-model="habitacion.CantidadNinios" min="0"
         class="form-control text-center" />
</td>
        <td>
          <button class="btn btn-danger btn-sm" @click="eliminarHabitacion(index)">Eliminar</button>
        </td>
      </tr>

      <tr class="fw-bold">
        <td colspan="4"></td>
        <td colspan="3" class="text-end">
          Total: <span :class="totalReserva > 0 ? 'text-success' : 'text-danger'">Q{{ totalReserva.toFixed(2) }}</span>
          <br>
          <small v-if="totalReserva === 0 && formulario.habitacionesSeleccionadas.length > 0" class="text-danger">
            ⚠️ Sin tarifa disponible para esta combinación
          </small>
        </td>
      </tr>
    </tbody>
  </table>
</div>


   <!-- Botón de Confirmar Reserva -->
<div class="mt-5 text-end">
<button
  @click="enviarDatos"
  class="btn btn-success"
  :disabled="formularioIncompleto || enviando">
  <span v-if="enviando">
    <i class="bi bi-hourglass-split me-2"></i>Procesando...
  </span>
  <span v-else>
    Confirmar Reserva
  </span>
</button>

</div>

    <!-- Payload debug -->

  </div>

  <!-- Modal personalizado -->
<div v-if="mostrarModalReserva" class="modal-fondo">
  <div class="modal-contenido">
    <h4 class="mb-3">Reserva confirmada</h4>
    <p>El código de la reserva es:</p>
    <h5 class="text-success">R00{{ codigoReserva }}</h5>

    <div class="text-end mt-4">
      <button class="btn btn-primary" @click="cerrarModalReserva">Aceptar</button>
    </div>
  </div>
</div>

</template>


<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'
import dayjs from '@/config/dayjs.js'
import { Toast } from 'bootstrap'
import { mapGetters } from 'vuex';

export default {
  name: 'ReservaCompleta',
  data() {
    return {
      enviando: false,
      formulario: {
        fechaInicio: '',
        fechaFin: '',
        huesped: {
          IdHuesped: null,
          Nombre: '',
          Apellido: '',
          Empresa: '',
          NIT: '',
          Telefono: '',
          DPI: '',
          Placas: '',
          Correo:'',

        },
        habitacionesSeleccionadas: []
      },
      habitaciones: [],
      tarifas: [],
      tiposHabitacion: [],
      promociones2:[],
      mensaje: '',
      hoy: dayjs().tz().format('YYYY-MM-DD'),
      huespedEncontrado: false,
      modoEdicion: false,
      yaBusque: false,
      alerta: {
        mensaje: '',
        tipo: 'success'
      },
      mostrarToast: false,
      codigoReserva: null,
      mostrarModalReserva: false,
      tipoPlaca: 'P0-',
      numeroPlaca: ''
    }
  },
  computed: {
    ...mapGetters(['getUser']),
  tarifasAgrupadas() {
  const agrupadas = {};

  // Primero, crear una entrada para TODOS los tipos de habitación
  this.tiposHabitacion.forEach(tipo => {
    agrupadas[tipo.Nombre] = {
      tarifas: [],
      promociones: tipo.promociones || []
    };
  });

  // Luego, agregar las tarifas existentes
  this.tarifas.forEach(tarifa => {
    const tipo = tarifa.tipo_habitacion?.Nombre || 'Sin Tipo';
    const promociones = tarifa.tipo_habitacion?.promociones || [];

    if (!agrupadas[tipo]) {
      agrupadas[tipo] = {
        tarifas: [],
        promociones: promociones
      };
    }

    agrupadas[tipo].tarifas.push(tarifa);
    agrupadas[tipo].promociones = promociones;
  });

  return agrupadas;
},
  minFechaFin() {
  return this.formulario.fechaInicio || this.hoy;
},
    formularioIncompleto() {
  return (
    this.formulario.habitacionesSeleccionadas.length === 0 ||
    !this.formulario.huesped.Nombre.trim() ||
    !this.formulario.huesped.Apellido.trim() ||
    this.totalReserva <= 0
  )
},
numeroNoches() {
  if (!this.formulario.fechaInicio || !this.formulario.fechaFin) return 1;
  const inicio = dayjs(this.formulario.fechaInicio);
  const fin = dayjs(this.formulario.fechaFin);
  const diff = fin.diff(inicio, 'day');
  return diff > 0 ? diff : 1;
},

    habitacionesPorTipo() {
      const orden = ['Simple', 'Doble', 'Triple', 'Cuadruple'];
      const agrupadas = {}

      this.habitaciones.forEach(hab => {
        const tipo = hab.tipo?.Nombre || 'Sin Tipo'
        if (!agrupadas[tipo]) agrupadas[tipo] = []
        agrupadas[tipo].push(hab)
      })

      // Ordenar las claves según el array 'orden'
      const ordenadas = {}
      orden.forEach(tipo => {
        if (agrupadas[tipo]) {
          ordenadas[tipo] = agrupadas[tipo]
        }
      })

      // Agregar tipos no listados al final
      Object.keys(agrupadas).forEach(tipo => {
        if (!orden.includes(tipo)) {
          ordenadas[tipo] = agrupadas[tipo]
        }
      })

      return ordenadas
    },
    totalReserva() {
      return this.formulario.habitacionesSeleccionadas.reduce((total, hab) => {
        return total + (Number(hab.precio) || 0)
      }, 0)
    },
    toastColor() {
      switch (this.alerta.tipo) {
        case 'success': return 'bg-success'
        case 'danger': return 'bg-danger'
        case 'warning': return 'bg-warning text-dark'
        case 'info': return 'bg-info text-dark'
        default: return 'bg-primary'
      }
    },
    iconoToast() {
      switch (this.alerta.tipo) {
        case 'success': return 'bi bi-check-circle-fill'
        case 'danger': return 'bi bi-x-circle-fill'
        case 'warning': return 'bi bi-exclamation-triangle-fill'
        case 'info': return 'bi bi-info-circle-fill'
        default: return 'bi bi-info-circle-fill'
      }
    }
  },
  watch: {
    'formulario.fechaInicio'() {
      this.manejarCambioFecha()
    },
    'formulario.fechaFin'() {
      this.manejarCambioFecha()
    },
    tipoPlaca() {
      this.actualizarPlacaCompleta()
    }
  },
  mounted() {
    this.obtenerTarifas()
    this.obtenerTiposHabitacion()
  },
  methods: {
    filtrarSoloNumeros() {
      this.formulario.huesped.Telefono = this.formulario.huesped.Telefono.replace(/\D/g, '').slice(0, 8)
    },
    actualizarPlacaCompleta() {
      // Combinar tipo de placa con número
      this.formulario.huesped.Placas = this.numeroPlaca ? `${this.tipoPlaca}${this.numeroPlaca}` : ''
    },
    mostrarAlerta(mensaje, tipo = 'success') {
      this.alerta.mensaje = mensaje
      this.alerta.tipo = tipo
      this.mostrarToast = true

      this.$nextTick(() => {
        const toastElement = document.querySelector('.toast')
        if (toastElement) {
          const toastBootstrap = new Toast(toastElement)
          toastBootstrap.show()
        }
      })
    },
    cerrarModalReserva() {
  this.mostrarModalReserva = false;
},
      formatDate(date) {
    if (!date) return '';
    return new Date(date).toLocaleDateString();
  },
    actualizarFechaFin() {
  },
    cerrarToast() {
      this.mostrarToast = false
    },
    manejarCambioFecha() {
      if (this.yaBusque) {
        this.formulario.habitacionesSeleccionadas = []
        this.habitaciones = []
        this.mensaje = ''
      }
      this.intentarBuscar()
    },
    async intentarBuscar() {
      if (this.formulario.fechaInicio && this.formulario.fechaFin) {
        //if (this.formulario.fechaInicio < this.hoy || this.formulario.fechaFin < this.hoy) {
          //this.mostrarAlerta('No puedes seleccionar fechas anteriores a hoy.', 'warning')
          //this.habitaciones = []
          //return
        //}
        await this.buscarHabitaciones()
      }
    },
    async buscarHabitaciones() {
      try {
        const res = await axios.post(`${API_URL}/habitaciones-disponibles`, {
          fecha_inicio: this.formulario.fechaInicio,
          fecha_fin: this.formulario.fechaFin
        })
        this.habitaciones = res.data.habitaciones
        this.mensaje = res.data.message
        this.yaBusque = true
      } catch (err) {
        console.error(err)
        this.mostrarAlerta('Error al buscar habitaciones, seleccione un rango de fechas correcto', 'danger')
        this.habitaciones = []
      }
    },
    async obtenerTarifas() {
      try {
        const res = await axios.get(`${API_URL}/precios-habitaciones`)
        this.tarifas = res.data
      } catch (err) {
        console.error('Error al obtener tarifas', err)
      }
    },
    async obtenerTiposHabitacion() {
      try {
        const res = await axios.get(`${API_URL}/tipohabitacion`)
        this.tiposHabitacion = res.data
      } catch (err) {
        console.error('Error al obtener tipos de habitación', err)
      }
    },
    agregarReserva(habitacion) {
      if (!this.formulario.habitacionesSeleccionadas.find(h => h.IdHabitacion === habitacion.IdHabitacion)) {
        this.formulario.habitacionesSeleccionadas.push({
          IdHabitacion: habitacion.IdHabitacion,
          Numero: habitacion.Numero,
          tipo: habitacion.tipo?.Nombre,
          precio: 0,
          IdTipoHabitacion: habitacion.tipo?.IdTipoHabitacion || null,
          CantidadPersonasAlojadas: 1,
          CantidadNinios: 0,
          CantidadCamas: habitacion.CantidadCamas || 1,
          CapacidadMaxima: habitacion.tipo?.CapacidadMaxima || 1
        })
        this.actualizarPrecio(this.formulario.habitacionesSeleccionadas.length - 1)
        this.mostrarAlerta(`Habitación #${habitacion.Numero} agregada`, 'success');
      }
    },
    actualizarPrecio(index) {
  const habitacion = this.formulario.habitacionesSeleccionadas[index];

  // Busca la tarifa para el tipo de habitación y cantidad de personas
  const tarifa = this.tarifas.find(t =>
    t.IdTipoHabitacion === habitacion.IdTipoHabitacion &&
    Number(t.CantidadPersonas) === habitacion.CantidadPersonasAlojadas
  );

  const precioBase = tarifa ? Number(tarifa.Precio) : 0;

  // ✅ 2️⃣ Usa tarifasAgrupadas para obtener promociones
  const grupo = this.tarifasAgrupadas[habitacion.tipo] || {};
  const promociones = grupo.promociones || [];

  let descuento = 0;

  if (promociones.length) {
    const fechaLlegada = new Date(this.formulario.fechaInicio);
    const fechaSalida = new Date(this.formulario.fechaFin);

    const promoActiva = promociones.find(p => {
      const inicioPromo = new Date(p.FechaInicio);
      const finPromo = new Date(p.FechaFin);
      return inicioPromo <= fechaSalida && finPromo >= fechaLlegada && Number(p.EstadoPromocion) === 1;
    });

    if (promoActiva) {
      descuento = Number(promoActiva.PorcentajeDescuento);
    }
  }

  habitacion.precioBase = precioBase;
  habitacion.descuento = descuento;

  const precioPorNoche = precioBase * (1 - descuento / 100);
  habitacion.precio = precioPorNoche * this.numeroNoches;
},



    eliminarHabitacion(index) {
      this.formulario.habitacionesSeleccionadas.splice(index, 1)
    },
   async buscarHuespedPorTelefono() {
      const telefono = this.formulario.huesped.Telefono
      if (!telefono) return

      try {
        const res = await axios.get(`${API_URL}/huesped/telefono/${telefono}`)
        if (res.data) {
          this.formulario.huesped = res.data
          this.huespedEncontrado = true
          this.modoEdicion = false

          // Separar placa en tipo y número
          if (res.data.Placas) {
            const placaCompleta = res.data.Placas
            const match = placaCompleta.match(/^([A-Z0-9]+-)(.*)/)
            if (match) {
              this.tipoPlaca = match[1]
              this.numeroPlaca = match[2]
            } else {
              this.tipoPlaca = 'P0-'
              this.numeroPlaca = placaCompleta
            }
          }

          this.mostrarAlerta('¡Huésped encontrado y cargado automáticamente!', 'success')
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          this.huespedEncontrado = false
          this.modoEdicion = false
          this.mostrarAlerta('Huésped no encontrado. Complete los datos.', 'info')
        } else {
          console.error('Error buscando huésped:', err)
          this.mostrarAlerta('Error buscando huésped.', 'danger')
        }
      }
    },
    habilitarEdicion() {
      this.modoEdicion = true
    },
    eliminarHuesped() {
      this.formulario.huesped = {
        IdHuesped: null,
        Nombre: '',
        Apellido: '',
        Empresa: '',
        NIT: '',
        Telefono: '',
        DPI: '',
        Placas: '',
        Correo:'',
      }
      this.tipoPlaca = 'P0-'
      this.numeroPlaca = ''
      this.huespedEncontrado = false
      this.modoEdicion = false
    },
    async actualizarHuesped() {
      try {
        await axios.put(`${API_URL}/huesped/${this.formulario.huesped.IdHuesped}`, this.formulario.huesped)
        this.mostrarAlerta('¡Huésped actualizado correctamente!', 'success')
        this.modoEdicion = false
      } catch (err) {
        console.error('Error actualizando huésped:', err)
        this.mostrarAlerta('Error actualizando huésped.', 'danger')
      }
    },
    generarPayload() {
  return {
    FechaReserva: dayjs().tz().format('YYYY-MM-DD HH:mm:ss'),
    FechaLlegada: this.formulario.fechaInicio,
    FechaSalida: this.formulario.fechaFin,
    IdHuesped: this.formulario.huesped.IdHuesped,
     IdEmpleado: this.getUser?.IdEmpleado || null,
    habitaciones: this.formulario.habitacionesSeleccionadas.map(h => ({
      IdHabitacion: h.IdHabitacion,
      CantidadPersonasAlojadas: h.CantidadPersonasAlojadas,
      CantidadNinios: h.CantidadNinios,
      CheckIn: h.CheckInAhora ? dayjs().tz().format('YYYY-MM-DD HH:mm:ss') : null,
      CheckOut: null
    }))
  }
}
,
    async enviarDatos() {
  // 🚫 Si ya se está enviando, evita ejecutar otra vez
  if (this.enviando) return;

  // 🚫 Validar que todas las habitaciones tengan precio válido
  const habitacionesSinPrecio = this.formulario.habitacionesSeleccionadas.filter(h =>
    !h.precio || h.precio <= 0
  );

  if (habitacionesSinPrecio.length > 0) {
    const habitaciones = habitacionesSinPrecio.map(h => h.Numero).join(', ');
    this.mostrarAlerta(
      `Las habitaciones ${habitaciones} no tienen tarifa disponible para la cantidad de personas seleccionadas. Verifica las tarifas en Gestión de Tarifas.`,
      'danger'
    );
    return;
  }

  this.enviando = true;

  try {
    let idHuesped = this.formulario.huesped.IdHuesped;

    // 🚩 1️⃣ Si NO existe, crear el huésped primero
    if (!idHuesped) {
      const nuevoHuesped = {
        Nombre: this.formulario.huesped.Nombre,
        Apellido: this.formulario.huesped.Apellido,
        Empresa: this.formulario.huesped.Empresa,
        NIT: this.formulario.huesped.NIT,
        Telefono: this.formulario.huesped.Telefono,
        DPI: this.formulario.huesped.DPI,
        Placas: this.formulario.huesped.Placas,
        Correo: this.formulario.huesped.Correo,
      };

      const resHuesped = await axios.post(`${API_URL}/huesped`, nuevoHuesped);

      idHuesped = resHuesped.data.IdHuesped;
      this.formulario.huesped.IdHuesped = idHuesped;
    }

    // 🚩 2️⃣ Genera payload usando IdHuesped REAL
    const payload = {
      FechaReserva: dayjs().tz().format('YYYY-MM-DD HH:mm:ss'),
      FechaLlegada: this.formulario.fechaInicio,
      FechaSalida: this.formulario.fechaFin,
      IdHuesped: idHuesped,
      IdEmpleado: this.getUser?.IdEmpleado || null,
      habitaciones: this.formulario.habitacionesSeleccionadas.map(h => ({
        IdHabitacion: h.IdHabitacion,
        CantidadPersonasAlojadas: h.CantidadPersonasAlojadas,
        CantidadNinios: h.CantidadNinios,
        CheckIn: h.CheckInAhora ? dayjs().tz().format('YYYY-MM-DD HH:mm:ss') : null,
        CheckOut: null
      }))
    };

    // 🚩 3️⃣ Enviar reserva
    const resReserva = await axios.post(`${API_URL}/reservas`, payload);

    this.codigoReserva = resReserva.data.IdReserva;
    this.mostrarModalReserva = true;

    this.mostrarAlerta('¡Reserva realizada con éxito!', 'success');

    // 🚩 4️⃣ Limpiar formulario y estado
    this.formulario = {
      fechaInicio: '',
      fechaFin: '',
      huesped: {
        IdHuesped: null,
        Nombre: '',
        Apellido: '',
        Empresa: '',
        NIT: '',
        Telefono: '',
        DPI: '',
        Placas: '',
        Correo: '',
      },
      habitacionesSeleccionadas: []
    };
    this.habitaciones = [];
    this.yaBusque = false;
    this.mensaje = '';
    this.huespedEncontrado = false;
    this.modoEdicion = false;
    this.tipoPlaca = 'P0-';
    this.numeroPlaca = '';

  } catch (err) {
    console.error('Error al enviar la reserva', err);
    this.mostrarAlerta('Hubo un error al enviar la reserva.', 'danger');
  } finally {
    // ✅ Siempre se desbloquea el botón
    this.enviando = false;
  }
}

  }
}
</script>





<style scoped>
.list-group-item {
  background-color: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 10px;
  border: 1px solid #dee2e6;
}

@media (max-width: 576px) {
  .list-group-item {
    flex-direction: column;
    align-items: flex-start !important;
  }
  .list-group-item button {
    width: 100%;
    margin-top: 10px;
  }
}

.table th, .table td {
  vertical-align: middle;
  text-align: center;
}

.btn {
  min-width: 120px;
}
.modal-fondo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-contenido {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
}

/* Sistema flexbox para habitaciones disponibles - Se ajusta dinámicamente */
.habitaciones-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: flex-start;
}

.habitacion-card-wrapper {
  flex: 1 1 280px;
  min-width: 280px;
  max-width: 400px;
}

/* Responsive para diferentes tamaños de pantalla */
@media (min-width: 768px) {
  .habitacion-card-wrapper {
    flex: 1 1 calc(50% - 1.5rem);
  }
}

@media (min-width: 992px) {
  .habitacion-card-wrapper {
    flex: 1 1 calc(33.333% - 1.5rem);
  }
}

@media (min-width: 1400px) {
  .habitacion-card-wrapper {
    flex: 1 1 calc(25% - 1.5rem);
  }
}

/* Estilos para tarjetas de tipos de habitación */
.card {
  min-width: 280px;
  max-width: 400px;
}

</style>
